import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashbordComponent } from './dashbord/dashbord.component';
import { TabViewComponent } from './tab-view/tab-view.component';
import { SideBarComponent } from '../../side-bar/side-bar.component';

import { TabViewModule } from 'primeng/tabview';
import { BeneficiaireComponent } from './beneficiaire/beneficiaire.component';
import { Angular2SmartTableModule } from 'angular2-smart-table';
import { CommandesComponent } from './commandes/commandes.component';
import { ParametresComponent } from './parametres/parametres.component';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { RippleModule } from 'primeng/ripple';
import { ToastModule } from 'primeng/toast';
import { RouterModule } from '@angular/router';
import { CustomActionComponent } from './custom-action/custom-action.component';
import { ProfilComponent } from './profil/profil.component';
import { SoldeComponent } from './solde/solde.component';
import { ModalComponent } from 'src/app/modal/modal.component';
import { AideComponent } from './aide/aide.component';

@NgModule({
  declarations: [
    DashbordComponent,
    TabViewComponent,
    SideBarComponent,
    BeneficiaireComponent,
    CommandesComponent,
    ParametresComponent,
    HeaderComponent,
    CustomActionComponent,
    ProfilComponent,
    SoldeComponent,
    AideComponent,
  ],
  imports: [
    CommonModule,
    TabViewModule,Angular2SmartTableModule,
    CardModule,DialogModule, ButtonModule, InputTextModule,
    BrowserAnimationsModule,InputSwitchModule,FormsModule,ReactiveFormsModule,
    DialogModule,RippleModule,ToastModule, RouterModule,
    ModalComponent
  ],
  exports: [
    DashbordComponent,
    TabViewComponent,
    SideBarComponent
  ]
})
export class EmployeModule { }
